import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Params, RouterLink } from '@angular/router';
import { CookieConsentService } from '../../../services/cookie-consent.service';

export interface AuraFooterLink {
  label: string;
  routerLink?: string;
  queryParams?: Params;
  href?: string;
}

export interface AuraFooterColumn {
  title: string;
  links: AuraFooterLink[];
}

export interface AuraFooterBadge {
  icon?: string;
  text: string;
}

@Component({
  selector: 'aura-footer',
  templateUrl: './footer.component.html',
  imports: [RouterLink, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraFooterComponent {
  private readonly cookieConsentService = inject(CookieConsentService, { optional: true });

  readonly companyName = input<string>('');
  readonly logoUrl = input<string>('/images/logo/logo.svg');
  readonly homeRoute = input<string>('/');
  readonly description = input<string | null>(null);
  readonly badge = input<AuraFooterBadge | null>(null);
  readonly columns = input<AuraFooterColumn[]>([]);
  readonly localeLabel = input<string | null>(null);
  readonly languageLabel = input<string>('Français (FR)');
  readonly currencyLabel = input<string | null>('€ EUR');
  readonly mentionsRoute = input<string>('/legal-mentions');
  readonly privacyRoute = input<string>('/privacy-policy');
  readonly cguRoute = input<string>('/terms-of-service');
  readonly maxWidthClass = input<string>('max-w-7xl');
  readonly showCookiesTrigger = input<boolean>(true);
  readonly openCookies = output<void>();

  readonly hasUpperSection = computed<boolean>(
    () => this.columns().length > 0 || Boolean(this.description()) || Boolean(this.badge()),
  );

  readonly currentYear = computed<number>(() => new Date().getFullYear());

  onOpenCookies(): void {
    this.openCookies.emit();
    this.cookieConsentService?.openPreferences();
  }
}
